"use client";

import { useEffect, useRef } from "react";

/**
 * React doesn't reliably set the `muted` *property* from the attribute, so
 * Chrome sees an unmuted video and blocks autoplay. Force it via ref, then
 * kick playback.
 */
export function HeroVideo() {
  const ref = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const v = ref.current;
    if (!v) return;
    v.muted = true;
    v.play().catch(() => {
      /* autoplay may still be blocked — the gradient fallback shows */
    });
  }, []);

  return (
    <video
      ref={ref}
      aria-hidden
      className="absolute inset-0 -z-20 h-full w-full object-cover opacity-55"
      src="/hero.mp4"
      poster="/hero-poster.jpg"
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
    />
  );
}
